export default "__VITE_ASSET__Bdhs8i0y__"